import React, { useState, useEffect, useRef } from 'react';
import './ContactModal.css';

const ContactModal = ({ isOpen, onClose }) => {
  const [hovered, setHovered] = useState(false);
  const cardRef = useRef(null);

  useEffect(() => {
    const syncPointer = (e) => {
      const { clientX: x, clientY: y } = e;
      
      if (cardRef.current) {
        cardRef.current.style.setProperty('--x', x.toFixed(2));
        cardRef.current.style.setProperty('--xp', (x / window.innerWidth).toFixed(2));
        cardRef.current.style.setProperty('--y', y.toFixed(2));
        cardRef.current.style.setProperty('--yp', (y / window.innerHeight).toFixed(2));
      }
    };

    if (isOpen) {
      document.addEventListener('pointermove', syncPointer);
      return () => document.removeEventListener('pointermove', syncPointer);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent("¡Hola! Me gustaría contactar con ustedes.");
    window.open(`https://wa.me/525562076934?text=${message}`, '_blank', 'noopener,noreferrer');
  };

  const handleFacebookClick = () => {
    window.open('https://www.facebook.com/Distrackersas', '_blank', 'noopener,noreferrer');
  };

  const cardStyles = {
    '--base': 220,
    '--spread': 200,
    '--radius': 16,
    '--border': 2,
    '--backdrop': 'hsl(0 0% 60% / 0.12)',
    '--backup-border': 'var(--backdrop)',
    '--size': 200,
    '--spotlight-size': 'calc(var(--size, 150) * 1px)',
    '--hue': 'calc(var(--base) + (var(--xp, 0) * var(--spread, 0)))',
    backgroundImage: `radial-gradient(
      var(--spotlight-size) var(--spotlight-size) at
      calc(var(--x, 0) * 1px)
      calc(var(--y, 0) * 1px),
      hsl(var(--hue, 210) calc(var(--saturation, 100) * 1%) calc(var(--lightness, 70) * 1%) / var(--bg-spot-opacity, 0.1)), transparent
    )`,
    backgroundColor: 'var(--backdrop, transparent)',
    backgroundSize: 'calc(100% + 4px) calc(100% + 4px)',
    backgroundPosition: '50% 50%',
    backgroundAttachment: 'fixed',
    border: '2px solid var(--backup-border)',
    position: 'relative',
    touchAction: 'none',
  };

  return (
    <div className="contact-modal-overlay" onClick={handleBackdropClick}>
      <div className="contact-modal">
        <div className="contact-modal-header">
          <h2>Contáctanos</h2>
          <button className="close-button" onClick={onClose}>
            <span>&times;</span>
          </button>
        </div>
        
        <div className="contact-modal-content">
          <div
            ref={cardRef}
            data-glow
            style={cardStyles}
            className="social-card"
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
          >
            {/* Background Pattern */}
            <div className="card-background-pattern" />

            {/* Header */}
            <div className="card-header">
              <h3>Conecta con Nosotros</h3>
              <p>Conecta con nosotros en redes sociales para actualizaciones y soporte</p>
            </div>

            {/* Social Icons */}
            <div className="social-icons-container">
              {/* WhatsApp Button */}
              <div className="social-button-group">
                <button
                  onClick={handleWhatsAppClick}
                  className="social-button whatsapp-button"
                >
                  <div className="social-icon whatsapp-icon">
                    <img src="/icons/whatsapp_icon.svg" alt="WhatsApp" />
                  </div>
                  <div className="button-glow" />
                </button>
                <div className="tooltip whatsapp-tooltip">
                  WhatsApp
                </div>
              </div>

              {/* Facebook Button */}
              <div className="social-button-group">
                <button
                  onClick={handleFacebookClick}
                  className="social-button facebook-button"
                >
                  <div className="social-icon facebook-icon">
                    <img src="/icons/facebook_icon.svg" alt="Facebook" />
                  </div>
                  <div className="button-glow" />
                </button>
                <div className="tooltip facebook-tooltip">
                  Facebook
                </div>
              </div>
            </div>

            {/* Email Addresses */}
            <div className="email-section">
              <p className="email-text">andres.gutierrez@distracker.com.mx</p>
              <p className="email-text">gerencia@distracker.com.mx</p>
            </div>

            {/* Floating Particles */}
            <div className="floating-particles">
              {[...Array(6)].map((_, i) => (
                <div
                  key={i}
                  className={`particle ${hovered ? 'animate-bounce' : ''}`}
                  style={{
                    backgroundColor: i % 2 === 0 ? '#10b981' : '#3b82f6',
                    left: `${20 + i * 60}px`,
                    top: `${60 + (i % 3) * 40}px`,
                    animationDelay: `${i * 200}ms`,
                    transform: hovered ? `translateY(-${(i + 1) * 10}px)` : "translateY(0)",
                  }}
                />
              ))}
            </div>

            {/* Gradient Overlay */}
            <div className="gradient-overlay" />
          </div>
          
          <div className="contact-footer">
            <p>Horario de atención: Lunes a Viernes 9:00 AM - 6:00 PM</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactModal;
